import { ITuiThiActionTypes } from "../../action-types/tct/ITuiThiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITuiThiReducer } from "../../reducer-model/tct/ITuiThiReducer";
const iniState: ITuiThiReducer = {
    dotThiIdSelected: 0
}
export const tuiThiReducer = (state: ITuiThiReducer = iniState, action: ITuiThiActionTypes): ITuiThiReducer => {
    const dotThiId = action?.payload?.dotThiId ?? 0;
    switch (action.type) {
        case "TUI_THI_CHANGE_DOT_THI_ID":
            return {
                ...state,
                dotThiIdSelected: dotThiId
            }
        case "TUI_THI_CHANGE_MONHOC_SELECTED_IDS":
            return {
                ...state,
                [dotThiId]: {
                    ...state[dotThiId],
                    monHocIdsSelected: action.payload.data,
                    phongThiIdsSelected: []
                }
            }
        case "TUI_THI_CHANGE_PHONGTHI_SELECTED_IDS":
            return {
                ...state,
                [dotThiId]: {
                    ...state[dotThiId],
                    phongThiIdsSelected: action.payload.data,
                    status: eReducerStatusBase.is_need_reload
                }
            }
        case "TUI_THI_LOAD_THISINH_START":
            return {
                ...state,
                [dotThiId]: {
                    ...state[dotThiId],
                    status: eReducerStatusBase.is_loading
                }
            }
        case "TUI_THI_LOAD_THISINH_SUCCESS":
            return {
                ...state,
                [dotThiId]: {
                    ...state[dotThiId],
                    status: eReducerStatusBase.is_completed,
                    thiSinhs: action.payload.data.data,
                    paging: {
                        ...action.payload.data,
                        data: []
                    },
                    page_index: action.payload.data.page_number

                }
            }
        case "TUI_THI_LOAD_THISINH_ERROR":
            return {
                ...state,
                [dotThiId]: {
                    ...state[dotThiId],
                    status: eReducerStatusBase.is_completed
                }
            }
        case "TUI_THI_CHANGE_DONG_TUI_MODAL_OPEN":
            return {
                ...state,
                [dotThiId]: {
                    ...state[dotThiId],
                    isOpenDongTuiModal: action.payload.data,
                    // Đóng modal (sau khi đóng túi xong) -> tải lại danh sách thí sinh để cập nhật SBD/số phách/túi số.
                    status: action.payload.data ? state[dotThiId]?.status : eReducerStatusBase.is_need_reload
                }
            }
        case "TUI_THI_CHANGE_PAGING_REQUEST":
            // debugger
            return {
                ...state,
                [dotThiId]: {
                    ...state[dotThiId],
                    status: eReducerStatusBase.is_need_reload,
                    page_index: action.payload.data.page_index,
                    search_key: action.payload.data.search_key,
                    
                }
            }
        default:
            return state;
    }

}